import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './SectionHead';
import Button from './Button';

/**
 * PageHero — L1 narrative hero for interior pages (05 §3.0).
 * Pass kicker to replace the long lead on compressed pillar pages.
 */
const PageHero = ({ id, eyebrow, title, lead, kicker, children, breadcrumb }) => (
  <section className="cy-section cy-page-hero-section" id={id}>
    <div className="cy-container">
      <div className="cy-page-hero">
        {breadcrumb}
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        <h1 className="cy-h1">{title}</h1>
        {kicker ? <p className="cy-kicker">{kicker}</p> : lead ? <p className="cy-lede">{lead}</p> : null}
        {children}
      </div>
    </div>
  </section>
);

const HeroCtas = ({ primary, primaryTo, secondary, secondaryTo, commit }) => (
  <div className="cy-hero-cta">
    <Button to={primaryTo}>{primary}</Button>
    {secondary ? (
      secondaryTo && secondaryTo.startsWith('#') ? (
        <a className="cy-link" href={secondaryTo}>
          {secondary}
        </a>
      ) : (
        <Link className="cy-link" to={secondaryTo}>
          {secondary}
        </Link>
      )
    ) : null}
    {commit ? <p className="cy-btn-commit">{commit}</p> : null}
  </div>
);

export { HeroCtas };
export default PageHero;
